<template>
  <div class="ccui-app-container">
    <div class="operation-group">
      <dialogtreetable
        @handleTrue="handleSelect"
        style="width: 100px;height: 30px;"
      ></dialogtreetable>

      <el-button class="ml" plain type="single-number" @click="handleCopy"
        >复制行
      </el-button>
      <el-button class="ml" plain type="single-number" @click="handleRemove"
        >删除行
      </el-button>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <ux-grid
        :edit-config="{ trigger: 'click', mode: 'cell' }"
        :max-height="417"
        :min-height="417"
        @row-click="handleRowClick"
        @select="listSelectTable"
        @select-all="listSelectTable"
        keep-source
        ref="purchaseList"
        show-overflow="title"
        widthResize
      >
        <ux-table-column
          align="center"
          min-width="50"
          type="checkbox"
          fixed="left"
        />

        <ux-table-column
          align="center"
          min-width="55"
          title="序号"
          type="index"
          fixed="left"
        />

        <ux-table-column
          field="materialsCode"
          min-width="120"
          resizable
          show-overflow-tooltip
          title="设备物资编码"
          fixed="left"
        >
        </ux-table-column>

        <ux-table-column
          field="materialsName"
          min-width="300"
          show-overflow-tooltip
          title="设备物资名称"
          fixed="left"
        >
          <!-- :width="flexColumnWidth('materialsName', purchaseList)" -->
        </ux-table-column>

        <ux-table-column
          :edit-render="{ autofocus: '.el-input__inner' }"
          field="matDescribe"
          min-width="150"
          resizable
          show-overflow-tooltip
          title="设备物资说明"
        >
          <template v-slot:edit="{ row }">
            <el-input maxlength="50" v-model="row.matDescribe" />
          </template>
          <template v-slot="{ row }">
            <span class="my-input-sc">{{ row.matDescribe }} </span>
          </template>
        </ux-table-column>

        <ux-table-column
          field="thirdCategoriesOfName"
          min-width="130"
          resizable
          show-overflow-tooltip
          title="分类名称"
        />

        <ux-table-column
          field="currentMeasuringUnit"
          min-width="90"
          resizable
          show-overflow="none"
          title="计量单位"
        >
          <template v-slot="{ row }">
            <el-tooltip
              :content="thirdCategoriesTooltip(row)"
              effect="dark"
              placement="top"
              v-if="row.isConversion"
            >
              <span>{{ row.currentMeasuringUnit }}</span>
            </el-tooltip>

            <span v-else>{{ row.currentMeasuringUnit }}</span>
          </template>
        </ux-table-column>

        <ux-table-column
          :edit-render="{ autofocus: '.el-input__inner' }"
          field="currentNum"
          min-width="140"
          resizable
          title="数量"
        >
          <template v-slot:edit="{ row }">
            <el-input
              @blur="testColumn($event, row, 'blur', 'currentNum')"
              @focus="testColumn($event, row, 'focus', 'currentNum')"
              v-if="isCurrentNumShow(row)"
              v-model="row.currentNum"
            />
            <span v-else>{{ row.currentNum }}</span>
          </template>
          <template v-slot="{ row }">
            <span
              :class="{
                'my-input-sc': isCurrentNumShow(row)
              }"
              >{{ row.currentNum }}
            </span>
          </template>
        </ux-table-column>

        <ux-table-column
          :edit-render="{ autofocus: '.el-input__inner' }"
          field="currentUnitPriceIncludeTax"
          min-width="140"
          resizable
          show-overflow="none"
          title="含税单价"
        >
          <template v-slot:edit="{ row }">
            <!-- 协议显示 tooltip -->
            <div v-if="row.matResource === '0' && row.priceType !== 4">
              <el-tooltip
                :content="priceTypeTooltip(row)"
                effect="dark"
                placement="top"
              >
                <input
                  @focus="
                    testColumn(
                      $event,
                      row,
                      'focus',
                      'currentUnitPriceIncludeTax'
                    )
                  "
                  class="el-input__inner"
                  v-if="isCurrentNumShow(row) && row.priceType !== 0"
                  v-model="row.currentUnitPriceIncludeTax"
                />
                <span v-else>{{ row.currentUnitPriceIncludeTax }}</span>
              </el-tooltip>
            </div>

            <div v-else>
              <input
                :disabled="row.priceType === 0"
                @focus="
                  testColumn($event, row, 'focus', 'currentUnitPriceIncludeTax')
                "
                class="el-input__inner"
                v-if="isCurrentNumShow(row) && row.priceType !== 0"
                v-model="row.currentUnitPriceIncludeTax"
              />
              <span v-else>{{ row.currentUnitPriceIncludeTax }}</span>
            </div>
          </template>

          <template v-slot="{ row }">
            <el-tooltip
              :content="priceTypeTooltip(row)"
              effect="dark"
              placement="top"
              v-if="row.matResource === '0' && row.priceType !== 4"
            >
              <span
                :class="{
                  'my-input-sc': isCurrentNumShow(row) && row.priceType !== 0
                }"
                >{{ row.currentUnitPriceIncludeTax }}</span
              >
            </el-tooltip>

            <span
              :class="{
                'my-input-sc': isCurrentNumShow(row) && row.priceType !== 0
              }"
              v-else
              >{{ row.currentUnitPriceIncludeTax }}</span
            >
          </template>
        </ux-table-column>

        <ux-table-column
          :edit-render="{ autofocus: '.el-input__inner' }"
          field="currentChangeAmtIncludeTax"
          min-width="140"
          resizable
          show-overflow-tooltip
          title="含税金额"
        >
          <template v-slot:edit="{ row }">
            <input
              @blur="
                testColumn($event, row, 'blur', 'currentChangeAmtIncludeTax')
              "
              class="el-input__inner"
              type="text"
              v-if="isCurrentTaxShow(row)"
              v-model.lazy="row.currentChangeAmtIncludeTax"
            />
            <span v-else>{{ row.currentChangeAmtIncludeTax }}</span>
          </template>
          <template v-slot="{ row }">
            <span :class="{ 'my-input-sc': isCurrentTaxShow(row) }"
              >{{ row.currentChangeAmtIncludeTax }}
            </span>
          </template>
        </ux-table-column>

        <ux-table-column
          field="deliveryTime"
          min-width="170"
          show-overflow-tooltip
          title="交货时间"
        >
          <template v-slot="{ row }">
            <el-date-picker
              placeholder="选择日期"
              type="date"
              v-if="isCurrentNumShow(row)"
              v-model="row.deliveryTime"
              value-format="yyyy-MM-dd"
            />
            <span v-else>{{ row.deliveryTime }}</span>
          </template>
        </ux-table-column>

        <ux-table-column
          field="purchasePlanCode"
          min-width="130"
          resizable
          show-overflow-tooltip
          title="采购计划编号"
        >
        </ux-table-column>

        <ux-table-column
          field="purchasePlanName"
          min-width="130"
          resizable
          show-overflow-tooltip
          title="采购计划名称"
        >
        </ux-table-column>

        <ux-table-column
          field="planCode"
          min-width="130"
          resizable
          show-overflow-tooltip
          title="方案编号"
        />

        <ux-table-column
          field="planName"
          min-width="130"
          resizable
          show-overflow-tooltip
          title="方案名称"
        />

        <ux-table-column
          field="protocalCode"
          min-width="130"
          resizable
          show-overflow-tooltip
          title="协议编号"
        >
        </ux-table-column>

        <ux-table-column
          field="protocalName"
          min-width="130"
          resizable
          show-overflow-tooltip
          title="协议名称"
        >
        </ux-table-column>
      </ux-grid>
    </div>
  </div>
</template>

<script>
import dialogtreetable from "./components/dialogtreetable";
import { formatNumber } from "@/basa/utils";
export default {
  name: "purchaseList",
  components: {
    dialogtreetable
  },
  data() {
    return {
      isMultiRate: true,
      purchaseList: []
    };
  },
  methods: {
    isCurrentTaxShow(row) {
      return false;
    },
    generateUUID() {
      let d = new Date().getTime();
      let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          let r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    handleSelect(arr) {
      if (arr.length) {
        let obj = arr.map((n, i) => ({
          ...n,
          isConversion: 0, // 是否转换过单位 => 0 未转换 1 转换
          onlyId: this.generateUUID(),
          baseProportion: 1,
          currentProportion: "",
          matResource: "3", // 0-框架协议，1=寻源结果，2=采购计划 3,=其他
          taxRate: 0,
          baseNum: 1,
          matDescribe: "", // 说明
          currentNum: "", // 数量
          deliveryTime: "", // 交货时间
          currentChangeAmtIncludeTax: "", // 含税金额
          currentChangeAmtExcludeTax: "", // 不含税金额
          currentUnitPriceExcludeTax: "", // 不含税单价
          currentUnitPriceIncludeTax: "", // 含税单价
          rate: 0, // 税额
          materialsName: n.matName, // 物装编码
          materialsCode: n.matNum,
          thirdCategoriesOfName: n.parentCategoriesName, // 三级
          thirdCategoriesOfCode: n.parentCategoriesCode,
          firstCategoriesOfName: n.majorCategoriesName, // 大类
          firstCategoriesOfCode: n.majorCategoriesCode,
          specifications: n.categoryName, // 规格型号
          specificationsCode: n.categoryCode,
          baseMeasuringUnit: n.unitStr, // 基础计量单位
          baseMeasuringUnitCode: n.unit,
          currentMeasuringUnit: n.unitStr, // 计量单位
          currentMeasuringUnitCode: n.unit,
          manufacturer: "",
          manufacturerDisabled: true, // 禁用生产厂家输入框
          smpBrandRelationReqBOS: [],
          deliveryPoints: ""
        }));
        this.purchaseList = obj;
        this.setDetailedTableList();
      }
    },
    // 删除
    handleRemove() {
      if (!this.listTableData.length) {
        this.$showErrorMessage("未选中复选框");
      } else {
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let temp = new Set(this.listTableData.map(n => n.onlyId));
            console.log(temp);
            // 删除所选
            this.purchaseList = this.purchaseList.filter(
              _ => !temp.has(_.onlyId)
            );

            // 重置复选框选中的数据
            this.listTableData = [];
            // this.$refs.purchaseList.clearSelection();

            this.setDetailedTableList();
          })
          .catch(() => {});
      }
    },
    setDetailedTableList() {
      this.$nextTick(() => {
        console.log(this.purchaseList);
        this.$refs.purchaseList.reloadData(this.purchaseList);
        setTimeout(() => {
          this.$refs.purchaseList.doLayout();
        }, 500);
      });
    },
    setToFixed(val, num) {
      return Number(val).toFixed(num);
    },

    getInputRule(val) {
      const reg = /(^(\d{0,11})\.(\d{0,8})$)|(^\d{0,20}$)/;
      return reg.test(val);
    },

    getType(obj) {
      return Object.prototype.toString
        .call(obj)
        .replace(/^\[object (\S+)\]$/, "$1");
    },
    testColumn(e, row, eventType, nameModel) {
      if (eventType === "blur") {
        if (e !== null) {
          e.target.style.border = `1px solid ${
            row[nameModel] ? "#ccc" : "red"
          }`;
        }

        // 截取小数后位数
        if (row[nameModel]) {
          if (
            this.getInputRule(row[nameModel]) &&
            [
              "currentNum",
              "currentUnitPriceIncludeTax",
              "currentChangeAmtIncludeTax"
            ].includes(nameModel)
          ) {
            row[nameModel] = formatNumber(
              Number(row[nameModel]),
              nameModel === "currentNum" ? 3 : 2
            );
          }

          // 计算 start
          if (this.isCurrentNumShow(row)) {
            if (
              row.currentNum &&
              row.currentUnitPriceIncludeTax &&
              this.getInputRule(row.currentNum) &&
              this.getInputRule(row.currentUnitPriceIncludeTax)
            ) {
              const newTaxRate = new this.$BigNumber(this.taxRateParams).plus(
                1
              );
              // 合同金额
              const price = this.setToFixed(
                new this.$BigNumber(row.currentNum).multipliedBy(
                  row.currentUnitPriceIncludeTax
                ),
                2
              );
              // 计算含税金额(含税)(单行)
              row.currentChangeAmtIncludeTax = this.setToFixed(price, 2);

              if (!this.getMultiRateCode) {
                const amtExcludeTax = new this.$BigNumber(price).dividedBy(
                  newTaxRate
                );
                // 计算不含税单价
                row.currentUnitPriceExcludeTax = this.setToFixed(
                  new this.$BigNumber(row.currentUnitPriceIncludeTax).dividedBy(
                    newTaxRate
                  ),
                  2
                );
                // 计算不含税金额
                row.currentChangeAmtExcludeTax = this.setToFixed(
                  amtExcludeTax,
                  2
                );
                // 计算税额
                row.rate = this.setToFixed(
                  new this.$BigNumber(price).minus(amtExcludeTax),
                  2
                );
              } else {
                if (row.taxRatePercent != "免税" && row.taxRatePercent) {
                  const val = row.taxRatePercent.substring(
                    0,
                    row.taxRatePercent.indexOf("%")
                  );
                  row.taxRate = Number(val) / 100;
                } else {
                  row.taxRate = 0;
                }
                const newTaxRate = new this.$BigNumber(row.taxRate).plus(1);
                const amtExcludeTax = new this.$BigNumber(price).dividedBy(
                  newTaxRate
                );
                // 计算不含税金额
                row.currentChangeAmtExcludeTax = this.setToFixed(
                  amtExcludeTax,
                  2
                );
                // 计算不含税单价
                row.currentUnitPriceExcludeTax = this.setToFixed(
                  new this.$BigNumber(row.currentUnitPriceIncludeTax).dividedBy(
                    newTaxRate
                  ),
                  2
                );
                // 计算税额
                row.rate = this.setToFixed(
                  new this.$BigNumber(price).minus(amtExcludeTax),
                  2
                );
              }
            } else {
              if (!this.getInputRule(row.currentNum)) {
                row.currentNum = "";
              }
              if (!this.getInputRule(row.currentUnitPriceIncludeTax)) {
                row.currentUnitPriceIncludeTax = "";
              }
              row.currentChangeAmtIncludeTax = "";
              row.currentChangeAmtExcludeTax = "";
              row.currentUnitPriceExcludeTax = "";
              row.rate = "";
            }
          }

          // 特殊 code 值的计算
          if (this.isCurrentTaxShow(row)) {
            if (
              row.currentChangeAmtIncludeTax &&
              this.getInputRule(row.currentChangeAmtIncludeTax)
            ) {
              if (!this.getMultiRateCode) {
                // 1 + 税率
                const newTaxRate = new this.$BigNumber(this.taxRateParams).plus(
                  1
                );
                // 不含税金额
                const amountExcludingTax = new this.$BigNumber(
                  row.currentChangeAmtIncludeTax
                ).dividedBy(newTaxRate);
                // 计算不含税金额
                row.currentChangeAmtExcludeTax = this.setToFixed(
                  amountExcludingTax,
                  2
                );

                // 计算税额
                row.rate = this.setToFixed(
                  new this.$BigNumber(row.currentChangeAmtIncludeTax).minus(
                    amountExcludingTax
                  ),
                  2
                );
              } else {
                // 截取税率
                if (row.taxRatePercent != "免税" && row.taxRatePercent) {
                  const val = row.taxRatePercent.substring(
                    0,
                    row.taxRatePercent.indexOf("%")
                  );
                  row.taxRate = Number(val) / 100;
                } else {
                  row.taxRate = 0;
                }
                // 1 + 税率
                const newTaxRate = new this.$BigNumber(row.taxRate).plus(1);
                // 不含税金额
                const amountExcludingTax = new this.$BigNumber(
                  row.currentChangeAmtIncludeTax
                ).dividedBy(newTaxRate);
                // 计算不含税金额
                row.currentChangeAmtExcludeTax = this.setToFixed(
                  amountExcludingTax,
                  2
                );
                // 计算税额
                row.rate = this.setToFixed(
                  new this.$BigNumber(row.currentChangeAmtIncludeTax).minus(
                    amountExcludingTax
                  ),
                  2
                );
              }
            } else {
              if (!this.getInputRule(row.currentChangeAmtIncludeTax)) {
                row.currentChangeAmtIncludeTax = "";
              }
              row.currentChangeAmtExcludeTax = "";
              row.rate = "";
            }
          }
        }
        // 计算 end
      }

      if (eventType === "focus") {
        if (e !== null) {
          e.target.style.border = "1px solid #0089EF";
        }
      }
    },
    // 复制
    handleCopy() {
      if (!this.listTableData.length) {
        this.$showErrorMessage("未选中复选框");
      } else {
        // const index = this.purchaseList.findIndex(
        //   item => item.onlyId === this.listTableData[0].onlyId
        // );
        // this.purchaseList.splice(index + 1, 0, {});

        this.purchaseList.push(
          ...this.listTableData.map((n, i) => ({
            materialsCode: n.materialsCode, // 物资编码
            materialsName: n.materialsName, // 物资名称
            matDescribe: n.matDescribe, // 物资说明
            thirdCategoriesOfName: n.thirdCategoriesOfName, // 三级
            thirdCategoriesOfCode: n.thirdCategoriesOfCode,
            firstCategoriesOfName: n.firstCategoriesOfName, // 大类
            firstCategoriesOfCode: n.firstCategoriesOfCode,
            baseMeasuringUnit: n.baseMeasuringUnit, // 基础计量单位
            baseMeasuringUnitCode: n.baseMeasuringUnitCode, // 基础计量单位
            currentMeasuringUnit: n.baseMeasuringUnit, // 当前计量单位
            currentMeasuringUnitCode: n.baseMeasuringUnitCode, // 当前计量单位
            specificationsCode: n.specificationsCode ?? "",
            currentChangeAmtIncludeTax: "", // 含税金额
            currentChangeAmtExcludeTax: "", // 不含税金额
            currentUnitPriceExcludeTax: "", // 不含税单价
            currentUnitPriceIncludeTax: "", // 含税单价
            currentNum: "", // 数量
            manufacturerDisabled: true,
            matResource: n.matResource,
            priceType: 4,
            rate: 0, // 税额
            id: null,
            isConversion: 0, // 是否转换过单位 => 0 未转换 1 转换
            onlyId: this.generateUUID()
          }))
        );

        this.setDetailedTableList();
        // 重置复选框选中的数据
        this.listTableData = [];
        // this.$refs.purchaseList.clearSelection();
      }
    },
    // 判断是否包含特殊 code 值
    isCurrentNumShow(row) {
      return true;
    },
    getMultiRateCode(newVal) {
      this.isMultiRate = newVal;

      // 切换多税率，重置清单中的计算
      this.purchaseList = this.purchaseList.map(n => ({
        ...n,
        currentNum: "", // 数量
        // currentChangeAmtExcludeTax: "",
        // currentUnitPriceExcludeTax: "",
        // currentUnitPriceIncludeTax: "", // 含税单价
        currentChangeAmtIncludeTax: "",
        rate: 0
      }));
    },
    // 行点击事件
    handleRowClick(row, column, event) {
      if (this.isCurrentNumShow(row)) {
        if (
          (["currentMeasuringUnit"].includes(column?.property) &&
            row.matResource === "3") ||
          ["address"].includes(column?.property)
        ) {
          this.rowParams = row;
          // 计量单位
          if (column.property === "currentMeasuringUnit") {
            // 在这里设置单位换算回显
            this.form.a = row.baseMeasuringUnit; // 基础单位
            this.form.b = row.currentMeasuringUnit; // 换算单位
            this.form.c = row.baseProportion; // 基础比列,默认1
            this.form.d = row.currentProportion; // 换算比列
            this.dialogVisible = true;
          }
          // 交货地点
          if (column.property === "address") {
            this.$refs.listSettings.showDialogVisible = true;
            this.$nextTick(() => {
              this.$refs.listSettings.init();
            });
          }
        }
      }
    },
    listSelectTable(val) {
      this.listTableData = val;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .ccui-multifunctional-table-wrapper {
  .el-table td,
  .el-table th.is-leaf {
    border-right: 1px solid #edf2fc !important;
  }
}

.el-date-editor.el-input {
  width: auto;
}

.ml {
  margin-left: 10px;
}

.operation-group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
}

.metering-dialog {
  .el-input,
  .el-select {
    width: 160px;
  }

  .dialog-icon {
    margin: 0 20px;
  }

  .dialog-span {
    margin: 0 23px;
  }
}

/deep/ .el-dropdown {
  .el-button.el-button--single-number {
    padding: 0 10px 0 20px;

    i {
      position: inherit;
    }
  }
}
/deep/ .el-input-group__append {
  .el-button {
    background: #f7f9ff;
    border: 1px solid #0089ef;

    & :hover {
      background-color: #fff;
      border-color: #5576cf;
      color: #fff;
    }

    span {
      color: #0089ef;
      font-size: 13px;
      font-weight: 500;
    }
  }
}
::v-deep {
  .input-readonly.el-input.is-input-readonly {
    input {
      background-color: rgb(229, 229, 229);
    }
  }
}
</style>
